module.exports = __webpack_public_path__ + "img/blog-33.7fe5447a.jpeg";